import React, { useEffect, useState } from "react";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";

export default function Toast({ message, type = "success", duration = 3000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);
    
    return () => clearTimeout(timer);
  }, [duration, onClose]);
  
  if (!isVisible) return null;
  
  const baseStyles = "fixed top-4 right-4 z-50 flex items-center p-4 rounded-lg shadow-lg";
  const successStyles = "bg-green-50 text-green-800 border border-green-200";
  const errorStyles = "bg-red-50 text-red-800 border border-red-200";
  
  const toastStyles = type === "success" ? successStyles : errorStyles;
  const Icon = type === "success" ? CheckCircleIcon : XCircleIcon;
  
  return (
    <div className={`${baseStyles} ${toastStyles}`} role="alert">
      <Icon className="w-5 h-5 mr-2" />
      <span className="font-medium">{message}</span>
    </div>
  );
}